import React from 'react';
import {Video, Formatted, Quote} from 'components';
import {config} from 'helpers';

export function Passion() {
  return (
    <div>
      <Formatted className="medium-spacing">
        <Video.Video src={config.videos.identity.passion} />
        <div className="medium-spacing">
          <p>Passion is about intense feelings or emotions that push you into action.</p>
          <p>But passion is a two-sided coin. On the bright side, our passion brings out our best self; one that is engaged in life. But for some people, passion can be scary because it puts you in touch with your more feeling and less-controlled self. The beauty of passion is that when harnessed it can be one of the most powerful and positive forces in our lives.</p>
          <p>Passion is the emotion of feeling very strongly about something or someone. Passion is what we feel when we are fully engaged with our life, when time moves unnoticeably and we can?t tell the difference between work and play, vacation and vocation!</p>
          <p>In this section, we invite you to give your mind a break and let your heart speak. Answer the following questions in that spirit.</p>
        </div>
      </Formatted>
      <Quote author="Proverb">
        Our passions are the winds that propel our vessel. Our reason is the pilot that steers her. Without winds the vessel would not move and without a pilot she would be lost.
      </Quote>
    </div>
  );
}
